<template>
  <div class="br-empty-banner">
    <img
      :src="iconUrl"
      class="br-empty-banner-icon"
      width="20"
      height="20"
      alt=""
    />
    <p class="br-empty-banner-text">
      {{ $t(messageKey) }}
    </p>
  </div>
</template>

<script>
import { BR_LICENSE_ASSETS } from '../../../constants/brLicenseAssets';

export default {
  name: 'BrEmptyBanner',
  props: {
    /**
     * true = 6c.2 Existing User（有 BR 历史但无已生效）
     * false = 6c.1 New User（尚未有任何 BR）
     */
    hasBrHistory: { type: Boolean, default: false },
  },
  computed: {
    iconUrl() {
      return BR_LICENSE_ASSETS.expirySoonAlertIcon;
    },
    messageKey() {
      return this.hasBrHistory
        ? 'lbl_EMPBE_BR_Empty_NoBrFound'
        : 'lbl_EMPBE_BR_Empty_NoBrFound_New';
    },
  },
};
</script>
